import { Match, MatchStatus, BracketType } from '../../domain/models';

// DTO que representa la estructura en Supabase
export interface MatchEntity {
  id: string;
  tournament_id: string;
  round: number;
  match_number: number;
  bracket_type: string;
  participant1_id: string | null;
  participant2_id: string | null;
  winner_id: string | null;
  status: string;
  score_participant1: number | null;
  score_participant2: number | null;
  next_match_id: string | null;
  loser_next_match_id: string | null;
  created_at: string;
  updated_at: string;
}

// Mapper: de Entity (DB) a Model (Domain)
export const matchEntityToModel = (entity: MatchEntity): Match => {
  return {
    id: entity.id,
    tournamentId: entity.tournament_id,
    round: entity.round,
    matchNumber: entity.match_number,
    bracketType: entity.bracket_type as BracketType,
    participant1Id: entity.participant1_id || undefined,
    participant2Id: entity.participant2_id || undefined,
    winnerId: entity.winner_id || undefined,
    status: entity.status as MatchStatus,
    scoreParticipant1: entity.score_participant1 || undefined,
    scoreParticipant2: entity.score_participant2 || undefined,
    nextMatchId: entity.next_match_id || undefined,
    loserNextMatchId: entity.loser_next_match_id || undefined,
    createdAt: new Date(entity.created_at),
    updatedAt: new Date(entity.updated_at),
  };
};

// Mapper: de Model (Domain) a Entity (DB)
export const matchModelToEntity = (model: Partial<Match>): Partial<MatchEntity> => {
  return {
    ...(model.tournamentId !== undefined && { tournament_id: model.tournamentId }),
    ...(model.round !== undefined && { round: model.round }),
    ...(model.matchNumber !== undefined && { match_number: model.matchNumber }),
    ...(model.bracketType !== undefined && { bracket_type: model.bracketType }),
    ...(model.participant1Id !== undefined && { participant1_id: model.participant1Id || null }),
    ...(model.participant2Id !== undefined && { participant2_id: model.participant2Id || null }),
    ...(model.winnerId !== undefined && { winner_id: model.winnerId || null }),
    ...(model.status !== undefined && { status: model.status }),
    ...(model.scoreParticipant1 !== undefined && { score_participant1: model.scoreParticipant1 || null }),
    ...(model.scoreParticipant2 !== undefined && { score_participant2: model.scoreParticipant2 || null }),
    ...(model.nextMatchId !== undefined && { next_match_id: model.nextMatchId || null }),
    ...(model.loserNextMatchId !== undefined && { loser_next_match_id: model.loserNextMatchId || null }),
  };
};
